import { PluginComponent } from "react-markdown-editor-lite";
import React from "react";

class TocPlugin extends PluginComponent {
  // Define plugin name here, must be unique
  static pluginName = "add-toc";
  // Define which place to be render, default is left, you can aslo use 'right'
  static align = "left";

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

async handleClick() {
    const { start } = this.editor.getSelection();

      const newCode = '[[TOC]]'
      this.editor.insertText(newCode, true);
      await new Promise((resolve) => {
        setTimeout(function(){
          resolve(); // ¡Todo salió bien!
        }, 100);
      })
      this.editor.setSelection({
        start: start + newCode.length,
        end: start + newCode.length
      })
  }

  render() {
    return (
      <span
        className="button button-type-counter"
        title="Añadir Índice"
        onClick={this.handleClick}
      >
        <i className="fas fa-list-alt"></i>
      </span>
    );
  }
}

export default TocPlugin;
